<template>
  <div class="container">
    <!-- 页面0 -->
    <div class="page0">
      <div class="content-wrapper">
        <!-- 左侧文字内容 -->
        <div class="text">
          <div class="title">觅思</div>
          <div class="subtitle">思念的人在这里</div>
        </div>
        <!-- 右侧图片 -->
        <div class="image">
          <img src="../../static/images/99.png" alt="Logo Overlay" />
        </div>
      </div>
    </div>

    <!-- 页面1 -->
    <div class="page1">
      <div class="title">海量真实用户</div>
      <div class="desc">私信秒回，陪你畅聊一整天</div>
      <div class="code">
        <img src="../../static/images/11.png" alt="QR Code" />
      </div>
    </div>

    <!-- 页面2 -->
    <div class="page2">
      <div class="title">随时发送动态</div>
      <div class="desc">分享你的生活，参与TA的人生</div>
      <div class="code">
        <img src="../../static/images/22.png" alt="QR Code" />
      </div>
    </div>

    <!-- 页面3 -->
    <div class="page3">
      <div class="title">立即下载</div>
      <div class="code">
        <img src="../../static/images/mslogo.png" alt="Logo" />
      </div>
      <div class="download">
        <img src="../../static/images/download.png" @click="download" alt="Download Android" />
        <img src="../../static/images/iosdownload.png" alt="Download iOS" />
      </div>
      <div class="beian">
        Copyright © 广西八骏马科技有限公司
        <a target="_blank" href="https://beian.miit.gov.cn">{{ beian }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      url: "http://xiayue-asset.oss-cn-shenzhen.aliyuncs.com/app/misi/misi.apk",
    };
  },
  methods: {
    download() {
      window.location.href = this.url;
    },
  },
  computed: {
    beian() {
      return "桂ICP备2023003001号";
    },
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  width: 100%;
  overflow-x: hidden;
}

.page0 {
  //padding: 2rem;
}

.content-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.text {
  flex: 1 1 40%;
  padding: 1rem;
  text-align: center;

  .title {
    font-size: 4rem;
    font-weight: bold;
  }

  .subtitle {
    font-size: 1.5rem;
    margin-top: 0.5rem;
  }
}

.image {
  flex: 1 1 50%;
  display: flex;
  justify-content: center;

  img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }
}

.page1,
.page2,
.page3 {
  text-align: center;

  .title {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    padding-top: 3rem;
  }

  .desc {
    font-size: 1.2rem;
    margin-bottom: 2rem;
  }

  .code img {
    max-width: 100%;
    height: auto;
  }
}

.page2 {
  background-color: #ff6550;
  color: #fff;
}

.page3 {
  .download img {
    width: 15rem;
    //margin: 0.5rem;
    margin: -4rem 4rem 9rem 4rem;
    cursor: pointer;
    padding-top: 6rem;
  }

  .beian {
    margin-top: 2rem;
    font-size: 1rem;
    color: #fff;
    background-color: #ff7562;
    padding: 1rem;
    line-height: 1.5;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
    text-align: center;
  }

  .text,
  .image {
    flex: 1 1 100%;
  }

  .text .title {
    font-size: 2.5rem;
  }

  .text .subtitle {
    font-size: 1rem;
  }

  .page1 .title,
  .page2 .title,
  .page3 .title {
    font-size: 2rem;
  }

  .download img {
    width: 8rem;
  }
}


/* 页面0样式 */
.page0 {

  .content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem; /* 控制两块内容之间的间距 */
  }

  .text {
    flex: 1 1 40%;
    text-align: center;

    .title {
      //font-size: 4rem;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }

    .subtitle {
      //font-size: 1.5rem;
      color: #666;
    }
  }

  .image {
    flex: 1 1 50%;
    display: flex;
    justify-content: flex-end; /* 图片向左调整 */
    padding-right: 0rem; /* 添加额外的右边距控制位置 */

    img {
      max-width: 170%;
      height: auto;
      object-fit: cover;
    }
  }
}
/* 响应式调整 */
@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: row; /* 保持左右排列 */
  }

  .text {
    flex: 1 1 50%; /* 左侧和右侧均分 */
    text-align: left; /* 保持左对齐，避免视觉怪异 */
    padding-left: 1rem;
  }

  .image {
    flex: 1 1 50%;
    justify-content: flex-end; /* 保持图片靠左调整 */
    padding-right: 0.5rem;

    img {
      max-width: 90%; /* 防止图片过大导致溢出 */
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/view/Index.vue